import { r } from '@/plugins/resource/resource'
import { queryPostfix } from '@/plugins/resource/api'

const MODEL = 'geo'

export const geoApi = {
  citiesList: r(queryPostfix('/cities/list/', ['search']), MODEL),
  countriesList: r(queryPostfix('/countries/list/', ['search']), MODEL),
  countriesListForFinancing: r(queryPostfix('/countries/for-financing-apply/list/', ['search']), MODEL)
}
